/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brushing your teeth for the full two minutes dentists recommend.`)
};

const es_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cepillarte los dientes durante los dos minutos completos que recomiendan los dentistas.`)
};

const de_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zähne die vollen zwei Minuten putzen, die Zahnärzte empfehlen.`)
};

const nl_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je tanden de volledige twee minuten poetsen die tandartsen aanraden.`)
};

const fr_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se brosser les dents pendant les deux minutes complètes recommandées par les dentistes.`)
};

const it_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lavarsi i denti per i due minuti completi raccomandati dai dentisti.`)
};

const pt_br2_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escovar os dentes pelos dois minutos completos recomendados pelos dentistas.`)
};

const pt_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escovar os dentes durante os dois minutos completos que os dentistas recomendam.`)
};

const ja_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歯科医が推奨する2分間フルで歯を磨く。`)
};

const zh_timer_u2m_use1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按牙医推荐完整刷牙两分钟。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u2m_use1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u2m_use1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u2m_use1", locale)
	if (locale === "en") return en_timer_u2m_use1(inputs)
	if (locale === "es") return es_timer_u2m_use1(inputs)
	if (locale === "de") return de_timer_u2m_use1(inputs)
	if (locale === "nl") return nl_timer_u2m_use1(inputs)
	if (locale === "fr") return fr_timer_u2m_use1(inputs)
	if (locale === "it") return it_timer_u2m_use1(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u2m_use1(inputs)
	if (locale === "pt") return pt_timer_u2m_use1(inputs)
	if (locale === "ja") return ja_timer_u2m_use1(inputs)
	return zh_timer_u2m_use1(inputs)
};